import React from "react";

const MealCardShimmer = () => {
  return (
    <div className="animate-pulse">
      {/* Image Skeleton */}
      <div className="relative overflow-hidden rounded-xl h-42 w-42 md:w-56 md:h-56 xl:w-64 xl:h-64 bg-gray-200">
        <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-[shimmer_1.5s_infinite]" />
      </div>

      {/* Content */}
      <div className="mt-3 space-y-2">
        <div className="h-4 bg-gray-200 rounded w-3/4"></div>

        <div className="h-3 bg-gray-200 rounded w-1/2"></div>

        <div className="flex items-center gap-2">
          <div className="h-4 w-4 bg-gray-200 rounded"></div>
          <div className="h-3 bg-gray-200 rounded w-32"></div>
        </div>

        <div className="h-4 bg-gray-200 rounded w-20"></div>
      </div>

      {/* Button */}
      <div className="mt-2 h-8 w-28 bg-gray-200 rounded-full"></div>
    </div>
  );
};

export default MealCardShimmer;
